import { useMutation, useQuery } from 'react-query';
import { RemoteNHISRepo } from '@repository/nhis/NHISRepo';
import NhisRequestAuthRq from '@domain/rq/nhis/NhisRequestAuthRq';

const remoteNHISRepo = new RemoteNHISRepo();

export const useNHISAuthCheck = () => {
  return useMutation(async () => {
    const { data } = await remoteNHISRepo.fetchNHISAuthCheck();
    return data;
  });
};

export const useNHISAuthRequest = () => {
  return useMutation((rq: NhisRequestAuthRq) => remoteNHISRepo.fetchNHISAuthRequest(rq));
};

export const useNHISCompaniesReport = () => {
  return useQuery(
    ['nhis', 'companies', 'report'],
    async () => {
      const { data } = await remoteNHISRepo.fetchNHISCompaniesReport();
      return data;
    },
    {
      staleTime: 5000,
      cacheTime: 5000,
    },
  );
};
